export default __webpack_public_path__ + "static/media/P20014.b451bff4.png";